import React, { ChangeEvent, useState } from "react";
import { Modal } from "react-bootstrap";
import { SelectWrapper } from "../../Common/Ui/SelectWrapper";
import { CustomInput } from "../../Common/Ui/CustomInput";
import { LoadingButton } from "../../Common/Ui/LoadingButton";
import { toast } from "react-toastify";

export const DocumentUploadModal: React.FC<{
  show: boolean;
  onClose: () => void;
  onUpload: (formData: FormData) => Promise<void>;
}> = (props) => {
  const documentOptions = [
    { value: "pancard", label: "Pancard", documentName: "pancard" },
    { value: "passPort", label: "Passport", documentName: "passPort" },
    { value: "other", label: "Other", documentName: "" },
  ];

  const [selectedDocumentOptions, setSelectedDocumentOptions] = useState<{
    value: string;
    label: string;
    documentName: string;
  }>();

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [uploadBtnLoading, setUploadBtnLoading] = useState(false);

  const uploadClick = async () => {
    try {
      setUploadBtnLoading(true);

      const formData = new FormData();

      const buffer = await selectedFile?.arrayBuffer();
      if (!buffer) {
        throw new Error("buffer not found");
      }

      formData.append("file", new Blob([buffer]), selectedFile?.name);
      formData.append(
        "documentName",
        selectedDocumentOptions?.documentName || ""
      );

      const uploadresponse: any = await props.onUpload(formData);

      if (uploadresponse.success) {
        toast.success("File Upload Successfully");
        props.onClose();
      }
    } catch (error: any) {
      console.log(error);
      toast.error(error?.message || "File upload failed");
    }

    setUploadBtnLoading(false);
  };

  return (
    <div>
      <Modal show={props.show} onHide={props.onClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Upload Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SelectWrapper
            options={documentOptions}
            onChange={(e) => {
              setSelectedDocumentOptions(e);
            }}
            value={selectedDocumentOptions?.value}
            className="mb-2"
          />
          {selectedDocumentOptions?.value === "other" && (
            <div className="mb-2">
              <CustomInput
                placeholder="Enter Document Name"
                value={selectedDocumentOptions.documentName}
                onChange={(e) => {
                  setSelectedDocumentOptions((old) => {
                    if (old) {
                      old.documentName = e.target.value;
                      return { ...old };
                    }

                    return undefined;
                  });
                }}
              />
            </div>
          )}

          {selectedDocumentOptions?.value && (
            <div>
              <CustomInput
                className="mb-2"
                type="file"
                onChange={async (e: ChangeEvent<HTMLInputElement>) => {
                  const maxSize = 2 * 1024 * 1024;
                  if (e.target.files) {
                    if (e.target.files[0].size > maxSize) {
                      return toast.error(
                        "File size exceeds the maximum limit of 2MB"
                      );
                    }
                    setSelectedFile(e.target.files[0]);
                  }
                }}
                accept="image/*,.pdf"
              />
              <LoadingButton
                loading={uploadBtnLoading}
                onClick={uploadClick}
                disabled={!selectedFile}
              >
                Upload
              </LoadingButton>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};
